import { logger } from 'logger'
import BlockTypes from '@slite/editor/lib/types/BlockTypes'

export default function makeUnfurlPlugin({
  handler = insertedBlocks => [],
} = {}) {
  async function getNodesAndInsert(editor, { insertedBlocks, insertedUrls }) {
    try {
      return await handler(editor, { insertedBlocks, insertedUrls })
    } catch (error) {
      logger.error(error)
      // just ignore the API errors
    }
  }

  async function onInsertFragment(command, editor, next) {
    next()

    if (editor.value.startBlock.type === BlockTypes.EMBED_PLACEHOLDER) {
      // Let's avoid triggering unfurls inside embed placeholders
      return
    }

    const insertedBlocks = command.args[0].getBlocks()
    await getNodesAndInsert(editor, { insertedBlocks })
  }

  async function onAddEmbed(command, editor, next) {
    const [
      url,
      bypassSuggestion = false,
      extractorsSelectorFilter = () => true,
      node = undefined,
    ] = command.args

    try {
      const hasInserted = await getNodesAndInsert(editor, {
        insertedUrls: [
          {
            url,
            bypassSuggestion,
            extractorsSelectorFilter,
            ref:
              (node && node.getIn(['data', 'id'])) ||
              editor.value.startBlock.getIn(['data', 'id']),
          },
        ],
      })

      if (!hasInserted) {
        return next()
      }
    } catch (error) {
      next()
    }
  }

  return [
    {
      onCommand(command, editor, next) {
        switch (command.type) {
          case 'insertFragment':
            return onInsertFragment(command, editor, next)
          case 'addEmbed':
            return onAddEmbed(command, editor, next)
          default:
            return next()
        }
      },
    },
  ]
}
